import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";
import LoginForm from "src/customer/login_form";
import React from "react";

export default class extends Controller {
  static targets = ["loginFormContainer"]

  declare loginFormContainerTarget: HTMLElement;
  declare hasLoginFormContainerTarget: boolean;

  connect() {
    if (this.hasLoginFormContainerTarget) {
      const root = createRoot(this.loginFormContainerTarget);
      root.render(
        React.createElement(
          LoginForm, { afterLoginCallback: () => { window.location.reload(); } }
        )
      );
    }
  }
}
